module.exports = __webpack_public_path__ + "media/nachhaltigkeit.46f868f8.mp4";